<template>
  <sparkline
    :id="id"
    :options="options"
    :value="`${value}%`"
    :year="`${year} grads`"
    :url="url"
  />
</template>

<script setup>
import Sparkline from "@/components/sparklines/Sparkline.vue"
import route from "ziggy-js"
import { computed, ref } from "vue"

const props = defineProps({
  school: { type: Object, required: true },
  field: { type: String, required: true },
})

const id = computed(() => `${props.school.slug}-${props.field}`)

const data = computed(() => {
  return props.school[props.field].map((s) => s.score)
})

const firstYear = computed(() => props.school[props.field][0].year)
const latestYear = computed(() => props.school[props.field].slice(-1)[0].year)

const year = ref(latestYear.value)
const value = ref(data.value[data.value.length - 1])
const url = computed(() => route("schools.jobs", props.school))

const options = computed(() => {
  const series = [{
    type: "areaspline",
    data: data.value,
    point: {
      events: {
        mouseOver() {
          value.value = this.y
          year.value = this.x + firstYear.value
        },
        mouseOut() {
          value.value = data.value[data.value.length - 1]
          year.value = latestYear.value
        },
      },
    },
  }]

  return {
    series,
  }
})
</script>
